import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import RealtimeState from '../../RealtimeState';
const CORE_POSTED_EVENT = 'Flarum\\Post\\Event\\Posted';
const CORE_RENAMED_EVENT = 'discussionRenamed';
const CORE_REVISED_EVENT = 'revisedEvent';
export default function () {
  extend(DiscussionPage.prototype, 'oninit', function () {
    this.websocketEventPosted = data => {
      var _this$discussion;
      const discussion = app.store.pushPayload(data);
      if (discussion.id() === ((_this$discussion = this.discussion) == null ? void 0 : _this$discussion.id()) && this.stream) {
        const oldCount = this.discussion.commentCount();
        app.store.find('discussions', this.discussion.id()).then(() => {
          this.stream.update().then(() => m.redraw());
          if (!document.hasFocus()) {
            app.setTitleCount(Math.max(0, this.discussion.commentCount() - oldCount));
            $(window).one('focus', () => {
              app.setTitleCount(0);
            });
          }
        });
      }
    };
    this.websocketEventStreamUpdate = data => {
      var _this$discussion2;
      const discussion = app.store.pushPayload(data);
      if (discussion.id() === ((_this$discussion2 = this.discussion) == null ? void 0 : _this$discussion2.id()) && this.stream) {
        app.store.find('discussions', this.discussion.id()).then(() => {
          this.stream.update().then(() => m.redraw());
        });
      }
    };
  });
  extend(DiscussionPage.prototype, 'oncreate', function () {
    var _app$websocket_channe, _app$websocket_channe2, _app$websocket_channe3, _app$websocket_channe4, _app$websocket_channe5, _app$websocket_channe6;
    (_app$websocket_channe = app.websocket_channels.public) == null || _app$websocket_channe.bind(CORE_POSTED_EVENT, this.websocketEventPosted.bind(this));
    (_app$websocket_channe2 = app.websocket_channels.user) == null || _app$websocket_channe2.bind(CORE_POSTED_EVENT, this.websocketEventPosted.bind(this));
    (_app$websocket_channe3 = app.websocket_channels.public) == null || _app$websocket_channe3.bind(CORE_RENAMED_EVENT, this.websocketEventStreamUpdate.bind(this));
    (_app$websocket_channe4 = app.websocket_channels.user) == null || _app$websocket_channe4.bind(CORE_RENAMED_EVENT, this.websocketEventStreamUpdate.bind(this));
    (_app$websocket_channe5 = app.websocket_channels.public) == null || _app$websocket_channe5.bind(CORE_REVISED_EVENT, this.websocketEventPosted.bind(this));
    (_app$websocket_channe6 = app.websocket_channels.user) == null || _app$websocket_channe6.bind(CORE_REVISED_EVENT, this.websocketEventPosted.bind(this));
    for (const eventName of RealtimeState.getDiscussionStreamEventNames()) {
      var _app$websocket_channe7, _app$websocket_channe8;
      (_app$websocket_channe7 = app.websocket_channels.public) == null || _app$websocket_channe7.bind(eventName, this.websocketEventStreamUpdate.bind(this));
      (_app$websocket_channe8 = app.websocket_channels.user) == null || _app$websocket_channe8.bind(eventName, this.websocketEventStreamUpdate.bind(this));
    }
  });
  extend(DiscussionPage.prototype, 'onremove', function () {
    var _app$websocket_channe9, _app$websocket_channe10, _app$websocket_channe11, _app$websocket_channe12, _app$websocket_channe13, _app$websocket_channe14;
    (_app$websocket_channe9 = app.websocket_channels.public) == null || _app$websocket_channe9.unbind(CORE_POSTED_EVENT);
    (_app$websocket_channe10 = app.websocket_channels.user) == null || _app$websocket_channe10.unbind(CORE_POSTED_EVENT);
    (_app$websocket_channe11 = app.websocket_channels.public) == null || _app$websocket_channe11.unbind(CORE_RENAMED_EVENT);
    (_app$websocket_channe12 = app.websocket_channels.user) == null || _app$websocket_channe12.unbind(CORE_RENAMED_EVENT);
    (_app$websocket_channe13 = app.websocket_channels.public) == null || _app$websocket_channe13.unbind(CORE_REVISED_EVENT);
    (_app$websocket_channe14 = app.websocket_channels.user) == null || _app$websocket_channe14.unbind(CORE_REVISED_EVENT);
    for (const eventName of RealtimeState.getDiscussionStreamEventNames()) {
      var _app$websocket_channe15, _app$websocket_channe16;
      (_app$websocket_channe15 = app.websocket_channels.public) == null || _app$websocket_channe15.unbind(eventName);
      (_app$websocket_channe16 = app.websocket_channels.user) == null || _app$websocket_channe16.unbind(eventName);
    }
  });
}